import * as maptiler from '@maptiler/sdk';
import '@maptiler/sdk/dist/maptiler-sdk.css';
import { useEffect } from 'react';
import { map } from './Map';
import { checkLngLatIsValid } from '../helpers/misc';

const ReplayPathMap = ({ positions }) => {
  const id = 'replay';

  useEffect(() => {
    map.addSource(id, {
      type: 'geojson',
      data: {
        type: 'Feature',
        geometry: {
          type: 'LineString',
          coordinates: [],
        },
      },
    });
    map.addLayer({
      source: id,
      id,
      type: 'line',
      layout: {
        'line-join': 'round',
        'line-cap': 'round',
      },
      paint: {
        'line-color': '#333',
        'line-width': 5,
      },
    });

    return () => {
      if (map.getLayer(id)) {
        map.removeLayer(id);
      }
      if (map.getSource(id)) {
        map.removeSource(id);
      }
    };
  }, []);

  useEffect(() => {
    const coordinates = positions.map((item) => [item.longitude, item.latitude]);
    map.getSource(id).setData({
      type: 'Feature',
      geometry: {
        type: 'LineString',
        coordinates,
      },
    });
    if (coordinates.length) {
      const bounds = new maptiler.LngLatBounds();
      coordinates.forEach(coord => {
        // console.log(`coord::::::`, coord);
        bounds.extend(coord);
      });
      map.fitBounds(bounds, {
        padding: {
          top: 50, bottom: 250, left: 25, right: 25,
        },
      });
    }
  }, [positions]);

  return null;
};

export default ReplayPathMap;
